module.exports = __webpack_public_path__ + "img/risk_assessment_img.8ef9033a.png";